module.exports = __webpack_public_path__ + "static/media/ic_康复计划.d2351389.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_康复计划.svg
// module id = 191
// module chunks = 0